"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FileSpreadsheetOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M26,8.59,20.41,3A3.733,3.733,0,0,0,18,2H7A2.006,2.006,0,0,0,5,4V28a2.006,2.006,0,0,0,2,2H25a2.006,2.006,0,0,0,2-2V11A3.733,3.733,0,0,0,26,8.59ZM19,4.41,24.59,10H19ZM25,28H7V4H17v7a1,1,0,0,0,1,1h7Z"/><path d="M21.5,14h-11A1.5,1.5,0,0,0,9,15.5v9A1.5,1.5,0,0,0,10.5,26h11A1.5,1.5,0,0,0,23,24.5v-9A1.5,1.5,0,0,0,21.5,14ZM15,18h6v2H15Zm-2,6H11V22h2Zm0-4H11V18h2Zm8,4H15V22h6Z"/>';
var FileSpreadsheetOutlineSVG = function FileSpreadsheetOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FileSpreadsheetOutlineSVG = FileSpreadsheetOutlineSVG;
FileSpreadsheetOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FileSpreadsheetOutlineSVG);
exports.default = _default;